export const COMPANIES_BACK_URL = 'back-url';
export const COMPANIES_SCROLL_INDEX = 'companies-scroll-index';
export const NAVIGATED_FROM_COMPANY_BREADCRUMB = 'navigated-from-company-breadcrumb';

export const TOP_MATCH_LIMIT = 15;
export const COMMAND_BAR_ID = '6ee9f5b0';
